        
<div class="d-flex justify-content-between justify-content-lg-end">
    @for(actionItem of taskActions; track actionItem.id){
        <button class="btn btn-action d-flex align-items-center px-lg-4 ms-lg-2" [ngClass]="actionItem.class" (click)="action(task, actionItem)">
            <div class="action-item-icon">
                <i class="fa-regular" [ngClass]="actionItem.icon"></i>
            </div>
            <div class="action-item-content px-2">
                <span class="action-item-title">{{actionItem.label.title | translate }}</span>
            </div>
        </button>
    }
</div>
